import { useState } from 'react';
import { Coins } from 'lucide-react';
import { useAiCreditsStatus } from '@/hooks/queries/useAiCredits';
import { cn } from '@/lib/utils';
import { AiCreditsPurchaseSheet } from './AiCreditsPurchaseSheet';

/**
 * Compact, ambient AI credits indicator for chat headers (Direction A).
 * Renders nothing until the status is known; highlights a low balance.
 */
export function ChatCreditsPill() {
  const { data: creditsStatus } = useAiCreditsStatus();
  const [purchaseOpen, setPurchaseOpen] = useState(false);

  if (!creditsStatus) return null;

  if (creditsStatus.unlimited) {
    return (
      <span className="inline-flex items-center gap-1.5 rounded-full border border-neutral-200 bg-neutral-50 px-3 py-1 text-xs font-semibold text-charcoal-700 dark:border-charcoal-700 dark:bg-charcoal-800 dark:text-charcoal-200">
        <Coins className="size-3.5 text-lime-600" aria-hidden />
        Illimité
      </span>
    );
  }

  if (creditsStatus.balance === undefined) return null;
  const low = creditsStatus.balance <= 10;

  return (
    <>
      <button
        type="button"
        onClick={() => setPurchaseOpen(true)}
        className={cn(
          'inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-semibold transition-all shadow-2xs border-0',
          'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-lime-400 focus-visible:ring-offset-2',
          low
            ? 'bg-amber-100 text-amber-800 hover:bg-amber-200'
            : 'bg-white text-slate-700 hover:bg-slate-100 dark:bg-charcoal-800 dark:text-slate-200 dark:hover:bg-charcoal-700',
        )}
        aria-label={`${creditsStatus.balance} crédits IA disponibles — Recharger les crédits`}
      >
        <Coins className="size-3.5 text-[#76b900]" aria-hidden />
        {creditsStatus.balance}
        <span className="font-normal text-slate-400">crédits</span>
        <span className="border-l border-slate-200 dark:border-charcoal-700 pl-1.5 font-semibold text-[#76b900]">
          Recharger
        </span>
      </button>

      <AiCreditsPurchaseSheet open={purchaseOpen} onOpenChange={setPurchaseOpen} quick />
    </>
  );
}
